// extracted by mini-css-extract-plugin
module.exports = {"purpleList":"style-module__purpleList___3SQv8","alignOnNonMobile":"style-module__alignOnNonMobile___eda_j"};